"use strict";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { TextPlugin } from "gsap/TextPlugin";

gsap.registerPlugin(ScrollTrigger, TextPlugin);

if (document.querySelector(".competence")) {
    document.querySelectorAll('.competence').forEach((competence) => {
        var header = competence.querySelector('.competence__header');
        var desc = competence.querySelector('.competence__desc');
        var arrowDown = header.querySelector('img[src*="down_arrow"]');
        var arrowUp = header.querySelector('img[src*="up_arrow"]');

        header.addEventListener('click', () => {
            var estActif = !desc.classList.contains('hiddenOpacity');
    
            document.querySelectorAll('.competence__desc').forEach((d) => d.classList.add('hiddenOpacity'));
            document.querySelectorAll('.competence__header img[src*="down_arrow"]').forEach((img) => img.classList.remove('hidden'));
            document.querySelectorAll('.competence__header img[src*="up_arrow"]').forEach((img) => img.classList.add('hidden'));
    
            if (estActif) {
                desc.classList.add('hiddenOpacity');
                arrowDown.classList.remove('hidden');
                arrowUp.classList.add('hidden');
            } else {
                desc.classList.remove('hiddenOpacity');
                arrowDown.classList.add('hidden');
                arrowUp.classList.remove('hidden');
            }
        });
    });
}

window.addEventListener("load", () => {
  const mainTitle = document.querySelector(".mainTitle");
  const secondTitles = document.querySelectorAll(".secondTitle");

  const hideText = (element) => {
    if (element) {
      element.style.visibility = 'hidden';
    }
  };

  const animateText = (element, delay = 0) => {
    if (element) {
      const textContent = element.textContent;
      element.style.visibility = 'visible';
      element.textContent = "";

      gsap.to(element, {
        text: { value: textContent },
        duration: textContent.length * 0.08,
        delay: delay,
        ease: "none",
      });
    }
  };

  hideText(secondTitles[0]);
  hideText(mainTitle);
  hideText(secondTitles[1]);

  animateText(secondTitles[0], 2.2);
  animateText(mainTitle, 3.3);
  animateText(secondTitles[1], 6);
});

gsap.utils.toArray('.section').forEach(section => {
  if (!section.classList.contains('header')) {
    gsap.from(section, {
      opacity: 0,
      y: 50,
      duration: 1,
      scrollTrigger: {
        trigger: section,
        start: 'top 80%',
        end: 'top 80%',
        toggleActions: 'play none none reverse',
      }
    });
  }
});

gsap.utils.toArray('.projet').forEach(projet => {
  gsap.from(projet, {
    opacity: 0,
    scale: 0.8,
    duration: 0.8,
    scrollTrigger: {
      trigger: projet,
      start: 'top 95%',
      end: 'top 95%',
      toggleActions: 'play none none reverse',
    }
  });
});

gsap.utils.toArray('.section.apropos p').forEach((p, index) => {
  gsap.from(p, {
    opacity: 0,
    y: 20,
    duration: 0.5,
    delay: index * 0.2,
    scrollTrigger: {
      trigger: p,
      start: 'top 100%',
      end: 'top 100%',
      toggleActions: 'play none none reverse',
    }
  });
});

window.addEventListener("load", () => {
    setTimeout(() => {
      const preloader = document.querySelector(".loader-container");
      preloader.style.opacity = "0";
      preloader.style.pointerEvents = "none";

      setTimeout(() => {
        preloader.style.display = "none";
      }, 500);
    }, 1500);
  });